import React from 'react';
import {
  //  Route,
  Switch,
} from 'react-router-dom';

import { PrivateRoute } from './PrivateRoute';

import { LoginRoutes } from './login';
import { DocumentRoutes } from './document';
import { Main } from 'pages/Main';
import { SettingsRoutes } from './settings';
import { Billing } from 'pages/ControlTower/Billing';
import { Financial } from 'pages/ControlTower/Financial';
import { Distribution } from 'pages/ControlTower/Distribution';
import { CheckFretes } from 'pages/ControlTower/CheckFretes';
// import { Maintenance } from 'pages/Maintenance';

export const Routes: React.FC = () => {
  return (
    <>
      {/* <Switch>
        <Route path="/" exact component={Maintenance} />
        <Route path="/base/base" exact component={Maintenance} />
        <Route path="/base" exact component={Maintenance} />
        <Route path="/login" exact component={Maintenance} />
        <Route path="/base/login" exact component={Maintenance} />
      </Switch> */}
      <Switch>
        <PrivateRoute path="/" exact component={Main} />
        <PrivateRoute path="/base/base" exact component={Main} />
        <PrivateRoute
          path="/control-tower/check-freights"
          exact
          component={CheckFretes}
        />
        <PrivateRoute
          path="/control-tower/distribution"
          exact
          component={Distribution}
        />
        <PrivateRoute path="/control-tower/billing" exact component={Billing} />
        <PrivateRoute
          path="/control-tower/financial"
          exact
          component={Financial}
        />
      </Switch>
      <LoginRoutes />
      <SettingsRoutes />
      <DocumentRoutes />
    </>
  );
};
